import type { ReactNode } from 'react';

import { Button } from '@opendoor/atoms/button';
import { IconCube3dSphere } from '@tabler/icons-react';

type GalleryMediaActionsProps = {
  videoAction?: ReactNode;
  tour3dUrl?: string;
};

export const GalleryMediaActions = ({ videoAction, tour3dUrl }: GalleryMediaActionsProps) => {
  if (!videoAction && !tour3dUrl) return null;

  return (
    <div
      role="group"
      aria-label="Media actions"
      className="gallery-media-actions"
      data-grouped={Boolean(videoAction && tour3dUrl)}
      data-pv="mediaActions"
    >
      {tour3dUrl && (
        <Button
          variant="secondary"
          size="md"
          analyticsName="pdp-refresh-view-in-3d"
          aria-label="View in 3D"
          href={tour3dUrl}
          className="gallery-action-button gallery-media-action"
        >
          <IconCube3dSphere size={18} stroke={2} aria-hidden="true" />
          <span className="gallery-media-label">View in 3D</span>
        </Button>
      )}
      {videoAction}
    </div>
  );
};
